module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-row",
    staticStyle: {
      "margin-left": "0px"
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _vm._l((_vm.categories), function(categoriesLevel, i) {
    return _c('form-group', {
      attrs: {
        "label": ((_vm.$t('category.label')) + " " + (_vm.$t('level.label')) + " " + ((i + 1))),
        "columns": 4
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedCategory[i]),
        expression: "selectedCategory[i]"
      }],
      staticClass: "form-select",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.selectedCategory, i, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.loadChildrenCategory(i)
        }]
      }
    }, _vm._l((categoriesLevel), function(category) {
      return _c('option', {
        key: category,
        domProps: {
          "value": category.id
        }
      }, [_vm._v(_vm._s(category.name))])
    }), 0)])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5251c326","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/mercadoLivre/sizeGrid/general/Category.vue
// module id = 3167
// module chunks = 0